import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';

export default class PlatformPartnersListStore extends ListStore {
  @computed get precessedData() {
    return this.data || [];
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.platforms.getPartnersSelect();
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
